import './index.css'
import Button from '../button';
import htmlDocx from 'html-docx-js/dist/html-docx';
import { useRef } from 'react';
import { saveAs } from 'file-saver';
import GoogleAuth from '../google-auth';
import { useState,useEffect } from 'react';
import IdeaScheduler from '../idea-scheduler';
import { editIdea } from '../../functions/editIdea';
import { deleteIdea } from '../../functions/deleteIdea';
import RegenModule from '../regen-module';
import ImageModule from '../image-module';

function ExpandedIdeaItem({renderedFeedItems,setFeedItems,display,title,structure,close,image,id,date}){
    const [tokenResponse, setTokenResponse] = useState(null);
    const [displayOfIdeaScheduler,SetDisplayOfIdeaScheduler] = useState('none');
    const [displayOfRegenModule,SetDisplayOfRegenModule] = useState('none');
    const [displayOfExpandedIdea,SetDisplayOfExpandedIdea] = useState(null);
    const [displayOfImageModule,SetDisplayOfImageModule] = useState("none");
    const [copyStatus,SetCopyStatus] = useState("Copy");
    const renderedFeedItemsRef = useRef([]);


    useEffect(() => {
        SetDisplayOfExpandedIdea(display);
        if(display==='block'){
            const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            // Create the new URL with the ID parameter
            const newUrl = `${baseUrl}?id=${(id)}`;
        
            // Use the history API to update the URL
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
    }, [display]);
    
    useEffect(() => {
        renderedFeedItemsRef.current = renderedFeedItems;
      }, [renderedFeedItems]);

    
    const handleScheduleClick = () => {
        SetDisplayOfIdeaScheduler("block");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });        
        document.body.style.overflow = "hidden";
    }


    const openRegenModule = () =>{
        SetDisplayOfRegenModule("block");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });
        document.body.style.overflow = "hidden";    
    }

    const closeRegenModule = () =>{
        SetDisplayOfRegenModule("none");
        document.body.style.overflowY = "scroll";
        document.body.style.overflowX = "hidden";
    }

    const closeScheduler = () => {
        SetDisplayOfIdeaScheduler("none");
        document.body.style.overflowY = "scroll";
        document.body.style.overflowX = "hidden";
    }

    const handleClose = () => {
        SetCopyStatus("Copy");
        SetEditObj({text:"Edit",image:"./images/scan.png",enabled:false,function:makeEditable});
        close()
    }

    const copyIdeaToClipBoard = () => {
        let value = document.getElementById("idea-content").innerText;
        navigator.clipboard.writeText(value);
        SetCopyStatus("Copied!");
    }

    const downloadToWord = (id) => { 
        const structure = document.getElementById("idea-content").innerText.replace(/\n/g, "<br>");
        const title = document.getElementsByTagName("h1")[0].innerText;
    
        const content = `
            <html>
                <head>
                    <meta charset="UTF-8">
                    <title>${title}</title>
                </head>
                <body>
                    <h1>${title}</h1>
                    <p style="white-space: pre-wrap;">${structure}</p>
                </body>
            </html>
        `;
    
        const converted = htmlDocx.asBlob(content);
        saveAs(converted, `${title}.docx`);
    };

    const confirmEdits = (id) => {
        let currentState = renderedFeedItemsRef.current;
        let updatedContent = document.getElementById("idea-content").innerText;
        updatedContent = updatedContent.replace(/\n{2,}/g, '\n\n');
        const newState = renderedFeedItemsRef.current.map(item =>
            item.id === id 
                ? { ...item, content: updatedContent }  // create a new object with updated content
                : item                                   // return the original item unchanged
        );
        setFeedItems(newState);
        SetEditObj({text:"Edit",image:"./images/scan.png",enabled:false,function:makeEditable});
        editIdea(id,updatedContent);
    }

    const makeEditable = (id) => {
        SetEditObj({text:"Confirm",image:"./images/scan.png",enabled:true,function:confirmEdits})
    }

    
    const confirmDeletion = () =>{
        SetDeleteObj({text:"Sure?",function : deleteThisIdea})
    }

    const [deleteObj,SetDeleteObj] = useState({text : "Delete", function:confirmDeletion});


    const deleteThisIdea = async(id) =>{
        await deleteIdea(id);
        window.location.href = "/ideas";
    }

    const openImageModule = async(id) =>{
        SetDisplayOfImageModule("flex");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });
                document.body.style.overflow = "hidden";        
    }

        const closeImageModule = async(id) =>{
        SetDisplayOfImageModule("none");
        window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });        
        document.body.style.overflow = "";
    }

    const [editObj,SetEditObj] = useState({text:"Edit",image:"./images/scan.png",enabled:false,function:makeEditable})

    let dateToDisplay;
    try{
        let dateParts = date.split(' ');
        let formattedDateString = `${dateParts[2]} ${dateParts[1]} ${dateParts[3]}`; // Convert to '02 Oct 2024' format
        let dateObject = new Date(formattedDateString);
        dateToDisplay = dateObject.toLocaleDateString();
    }
    catch{
        dateToDisplay = ' '
    }
    return <><div className='expanded-idea' style={{display:displayOfExpandedIdea}}>
    <div className='expanded-idea-header'>
    <h1 className='big-text'>{title}</h1>
    <img className='close' src='./images/close.png' onClick={handleClose} id="desktop-close"></img>
    </div>
    <div className='info-holder-expanded'>
    <div className='export-holder'>
        <Button image='./images/download_word.png' text='Download' smallBool={false} addedFunction={downloadToWord} params={id}/>
        <Button image='./images/schedule.png' text='Schedule' smallBool={false} addedFunction={handleScheduleClick} params={id}/>
        <Button image='./images/copy.png' text={copyStatus} smallBool={false} addedFunction={copyIdeaToClipBoard} params={id}/>
        <Button image={editObj.image} text={editObj.text} smallBool={false} addedFunction={editObj.function} params={id}/>
        <Button image='./images/regenerate.png' text="Regenerate" smallBool={false} addedFunction={openRegenModule} params={id}/>
        <Button image='./images/image.png' text="Image" smallBool={false} addedFunction={openImageModule} params={id}/>
        <Button image='./images/white-bin.png' text={deleteObj.text} smallBool={false} addedFunction={deleteObj.function} params={id}/>

    </div>
    <div className='export-holder' id='extra-info-holder'>
    <div style={{display : date ? 'flex' : 'none'}} className='scheduled-date-expanded'>
        <div className='value-date small-text'>{dateToDisplay}</div>
    </div>
    <img className='close' id="mobile-close" src='./images/close.png' onClick={handleClose}></img>
    </div>
    </div>
    <p id='idea-content' style={{border: editObj.enabled ? "2px solid #0AFB60" : "none"}} contentEditable={editObj.enabled}>{structure.replace(/\*/g,"")}</p>
    </div>
    <RegenModule id={id} display={displayOfRegenModule} close={closeRegenModule}/>
    <IdeaScheduler close={closeScheduler} display={displayOfIdeaScheduler} id={id} />
    <ImageModule display={displayOfImageModule} functionForButton={closeImageModule} image={image} id={id}/>
    </>
}

export default ExpandedIdeaItem